<template>
  <div class="approvalInfo" id="approvalInfo">
    <div class="pagetitle">
      {{ previewList.title }}
    </div>

    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item
        :name="index"
        v-for="(item, index) in previewList.situation"
        :key="index"
        :id="'collapse' + index"
      >
        <template #title>
          <div class="title">
            <span>{{ index }}</span>
          </div>
        </template>
        <template #default>
          <template v-for="(item1, index1) in item">
            <div :key="index1">
              <!-- 横线 -->
              <van-divider v-if="index1 > 0"></van-divider>
              <template v-for="(item2, index2) in item1">
                <div :key="index2" class="top-cont-text">
                  <div class="left">{{ index2 }}：</div>
                  <div class="right">
                    {{ item2 }}
                  </div>
                </div>
              </template>
            </div>
          </template>
        </template>
      </van-collapse-item>
    </van-collapse>
    <!-- <div class="cont-footer">
      珠海红塔仁恒包装股份有限公司版权所有
    </div> -->
  </div>
</template>
<script>
// import moment from "moment";
export default {
  data() {
    return {
      activeNames: ["0"],
      previewList: []
    };
  },
  mounted() {
    this.getPreviewList();
  },
  methods: {
    getPreviewList() {
      let data = {};
      let url = "";
      if (this.type === "list") {
        data.id = this.id;
        url = "/api/psummary/wxwork/detail_summary";
      } else {
        data.preview_key = this.id;
        url = "/api/psummary/wxwork/preview_summary";
      }
      this.$common
        .http({
          url: url,
          data: data
        })
        .then(res => {
          // let res = {
          //   data: {
          //     data: {}
          //   }
          // };
          console.log(res.data.data);
          // res.data.data = {
          //   id: "1",
          //   title: "20200903汇总情况",
          //   user_list: ["9135451"],
          //   dept_list: ["509675"],
          //   publish_timing: 0,
          //   situation: [
          //     {
          //       流程名:
          //         "中国纸业总部8月24日-8月30日值班带班表-外来文件传阅单（红塔仁恒）-赖安迪",
          //       流程编号: "HTRH-WLWJCY-202008240001",
          //       流程创建人: "赖安迪",
          //       上级部门: "总经理办公室",
          //       审批时间: "25-8月 -20 03.36.56.088000000 下午",
          //       审批节点: "N8",
          //       审批节点名称: "部门分管领导",
          //       实际审批人员名: "吴义荣"
          //     }
          //   ],
          //   standby_state: 1,
          //   class_id: "2",
          //   class_name: "名称2",
          //   state: 1,
          //   push_time: null
          // };
          this.previewList = res.data.data;
        });
    }
  },
  created() {},
  computed: {
    id() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    }
  }
};
</script>
<style lang="less" scoped>
.approvalInfo {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;
  font-size: 16px;
  .pagetitle {
    height: 30px;
    text-align: center;
    background: #fff;
    padding: 10px 0px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .top-cont {
    display: flex;
    background: #fff;
    .time {
      flex: 1.7;
      font-size: 14px;
      line-height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9b9b9b;
      height: 25px;
      margin-top: 9px;
      background: #f4f5f6;
      margin: 9px 15px 0px 11px;
    }
  }
  .cont1 {
    display: flex;
    & > div {
      flex: 1;
    }
    .blk {
      background: #fff;
      font-size: 16px;
      display: flex;
      margin: 10px 0px;
      border-right: 1px solid #f4f5f6;
      justify-content: center;
      align-items: center;
      height: 46px;
      .left {
        flex: 1;
      }
      .right {
        flex: 0.5;
        text-align: right;
      }
    }
  }
  .top-cont-text {
    padding: 0px 0px 14px;
    background: #fff;
    font-size: 16px;
    display: flex;
    .left {
      // display: inline-block;
      // width: calc(33vw - 5px);
      text-align: right;
      margin-right: 15px;
      vertical-align: top;
      color: #b2b2b2;
      flex: 1;
    }
    .right {
      // display: inline-block;
      // width: calc(63vw - 30px);
      vertical-align: top;
      word-break: break-all;
      color: #000;
      flex: 1.5;
    }
  }
  .cont-footer {
    text-align: center;
    font-size: 14px;
    color: #999999;
    padding: 0px 0px 20px;
    position: fixed;
    width: 100vw;
    bottom: 0px;
  }
  .colorB2 {
    color: #b2b2b2;
  }
  .rightIcon {
    font-size: 20px;
    padding: 8px 0px 0px 0px;
    line-height: 36px;
  }
  .title {
    // padding: 8px 0px 8px 0px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
  }
  .title-left {
    display: inline-block;
    background: #e5f3ee;
    padding: 1px 10px;
    color: #008b5e;
    margin-left: 14px;
  }
  .first {
    transition: all 1s;
  }
  .van-cell {
    font-size: 16px;
  }
}
</style>
<style lang="less">
#approvalInfo .van-cell__right-icon {
  line-height: 42px;
}
</style>
